/*!
 * Copyright 2019 Fondazione Bruno Kessler
 * Licensed under the EUPL, Version 1.1 or - as soon they will be approved by the European
 * Commission - subsequent versions of the EUPL (the "Licence"); You may not use this work
 * except in compliance with the Licence.
 *
 * You may obtain a copy of the Licence at:
 * http://ec.europa.eu/idabc/eupl.html
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the Licence is distributed on an "AS IS" basis, WITHOUT WARRANTIES OR CONDITIONS OF
 * ANY KIND, either express or implied. See the Licence for the specific language
 * governing permissions and limitations under the Licence.
 */

export const enum CustomPreferencesTreatmentPlan {
  THERAPIES_LIST_SORT = "tp_therapies_list_sort",
  THERAPIES_LIST_HIDDEN_COLS = "tp_therapies_list_hidden_cols",
}

/**
 * Resolver Key for treatment plan sections configuration data.
 */
export const TP_DATA_RESOLVER_TP_CONFIG = "tpConfig";
